import { MediaType } from 'src/app/shared-form-sections/types/media-type';
import { IImage } from '../../models/i-image';
import { IVideoMediaDto } from './i-video-media-dto';

export interface ISlide {
  id: number;
  order: number;
  body?: string;
  caption?: string;
  mediaId?: string;
  mediaThumbnailUrl?: string;
  mediaTitle?: string;
  mediaType?: MediaType;
  inlineImages?: IImage[];
  inlineVideos?: IVideoMediaDto[];
}

export class Slide implements ISlide {
  constructor(
    public id: number,
    public order: number,
    public body?: string,
    public caption?: string,
    public mediaId?: string,
    public mediaThumbnailUrl?: string,
    public mediaTitle?: string,
    public mediaType?: 'VIDEO' | 'IMAGE',
    public inlineImages?: IImage[],
    public inlineVideos?: IVideoMediaDto[]
  ) {}
}
